import React, { useEffect, useState } from "react";
import PlanTableCellDay from "../PlanTableCellDay/PlanTableCellDay";
import PlanTableCellHour from "../PlanTableCellHour/PlanTableCellHour";
import PlanTableCellMerged from "../PlanTableCellMerged/PlanTableCellMerged";
import { PlusIcon, XIcon, SaveIcon, UploadIcon, EyeIcon, DownloadIcon } from '@heroicons/react/outline'
import PlanService from "../../../services/PlanService";
import { Link } from "react-router-dom";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import PlanTableCellSum from "../PlanTableCellSum/PlanTableCellSum";
import Select from 'react-select'
import { DEFAULT_INDIVIDUAL_RECOMMENDATIONS } from "../../../services/PlanDefaults";

const MySwal = withReactContent(Swal)

const TabContent = ({ openTab, options, planData, setPlanData, sendPlan, addPlan, savePlan, noOfRows, setNoOfRows, noOfCommentRows, setNoCommentOfRows, planIndex, selectExistingClientsPlan, clients, selectedClient, usedRecipes }) => {
  const plan = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
    times: [],
    comments: [],
    mergedRows: [],
    substituteSet: 'regular',
    lunchRecommendationRows: [],
    individualRecommendations: DEFAULT_INDIVIDUAL_RECOMMENDATIONS
  }

  const SUBSTITUTE_SET_OPTIONS = [
    { value: 'regular', label: 'Regularne' },
    { value: 'vegetarian', label: 'Vegetarijanske' }
  ]

  const setSubstituteSet = (value) => {
    let temp = planData ? { ...planData } : { ...plan }
    temp.substituteSet = value
    setPlanData({ ...temp }, planIndex)
  }

  const setIndividualRecommendations = (value) => {
    let temp = planData ? { ...planData } : { ...plan }
    temp.individualRecommendations = value
    setPlanData({ ...temp }, planIndex)
  }

  useEffect(() => {
    mapExistingPlanData(planData)
  }, [])

  // Kad se promeni sam plan (npr. prebacivanje jelovnika), osvezi broj redova
  // i komentara da tabela prikaze novi jelovnik. Reagujemo SAMO na identitet
  // jelovnika (id + redni broj), ne na broj vremena - da dodavanje reda u toku
  // rada ne bi resetovalo tabelu.
  const planKey = planData
    ? (planData.id || 'nov') + '|' + (planData.menuNumber || '')
    : '';
  useEffect(() => {
    if (planData) {
      // prazan jelovnik (bez vremena) dobija podrazumevane redove da bi se
      // videla polja za dodavanje obroka; sacuvan jelovnik dobija svoj broj
      const rows = (planData.times && planData.times.length) ? planData.times.length : 4;
      const comments = planData.comments ? planData.comments.length : 0;
      setNoOfRows(rows, planIndex);
      setNoCommentOfRows(comments, planIndex);
    }
  }, [planKey])


  const addMeal = (meal, day, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp[day][index] = meal
    setPlanData({ ...temp }, planIndex)
  }

  const removeMeal = (meal, day, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp[day][index] = null;
    setPlanData({ ...temp }, planIndex)
  }

  const setTime = (time, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp["times"][index] = time
    setPlanData({ ...temp }, planIndex)
  }

  const ALL_DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]

  const toggleMerged = (index) => {
    let temp = planData ? { ...planData } : { ...plan }
    let merged = temp.mergedRows ? [...temp.mergedRows] : []
    let mergedDays = temp.mergedDays ? { ...temp.mergedDays } : {}
    let lunchRecs = temp.lunchRecommendationRows ? [...temp.lunchRecommendationRows] : []
    if (merged.includes(index)) {
      merged = merged.filter(i => i !== index)
      delete mergedDays[index]
      lunchRecs = lunchRecs.filter(i => i !== index)
    } else {
      merged.push(index)
      mergedDays[index] = [...ALL_DAYS]
    }
    temp.mergedRows = merged
    temp.mergedDays = mergedDays
    temp.lunchRecommendationRows = lunchRecs
    setPlanData({ ...temp }, planIndex)
  }

  // Ukljuci/iskljuci preporuke za rucak za spojeni red (dva saveta iznad i ispod).
  const toggleLunchRecs = (index) => {
    let temp = planData ? { ...planData } : { ...plan }
    let list = temp.lunchRecommendationRows ? [...temp.lunchRecommendationRows] : []
    if (list.includes(index)) {
      list = list.filter(i => i !== index)
    } else {
      list.push(index)
    }
    temp.lunchRecommendationRows = list
    setPlanData({ ...temp }, planIndex)
  }

  const toggleMergedDay = (index, day) => {
    let temp = planData ? { ...planData } : { ...plan }
    let merged = temp.mergedRows ? [...temp.mergedRows] : []
    let mergedDays = temp.mergedDays ? { ...temp.mergedDays } : {}
    let days = mergedDays[index] ? [...mergedDays[index]] : [...ALL_DAYS]
    if (days.includes(day)) {
      days = days.filter(d => d !== day)
    } else {
      days.push(day)
    }
    if (days.length === 0) {
      merged = merged.filter(i => i !== index)
      delete mergedDays[index]
      let lr = temp.lunchRecommendationRows ? [...temp.lunchRecommendationRows] : []
      temp.lunchRecommendationRows = lr.filter(i => i !== index)
    } else {
      if (!merged.includes(index)) merged.push(index)
      mergedDays[index] = days
    }
    temp.mergedRows = merged
    temp.mergedDays = mergedDays
    setPlanData({ ...temp }, planIndex)
  }


  const addComment = (comment, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp["comments"][index] = comment
    setPlanData({ ...temp }, planIndex)
  }

  const removeComment = () => {
    if (noOfCommentRows !== 0) {
      let index = noOfCommentRows - 1
      setNoCommentOfRows(index, planIndex)

      let temp = {}
      if (planData) {
        temp = { ...planData }
      } else {
        temp = { ...plan }
      }
      temp["comments"][index] = null;
      setPlanData({ ...temp }, planIndex)
    }
  }

  const mapExistingPlanData = (existingPlan) => {
    if (existingPlan) {
      let tempPlan = { ...existingPlan }
      setPlanData({ ...tempPlan }, planIndex)
      setNoCommentOfRows(tempPlan.comments.length, planIndex)
    }
  }

  const downloadPdf = () => {
    PlanService.downloadPdf(planData ? planData : plan).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const cd = response.headers['content-disposition'] || '';
      let filename = 'plan.pdf';
      const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
      const plain = cd.match(/filename="?([^";]+)"?/i);
      if (star) filename = decodeURIComponent(star[1]);
      else if (plain) filename = plain[1];
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }).catch(async (error) => {
      // Server vise ne vraca prazan PDF - kad nesto ne uspe posalje objasnjenje,
      // pa ga ovde prikazujemo umesto da se fajl od 0 bajta tiho skine
      let poruka = 'Server nije uspeo da napravi PDF. Proveri da li je aplikacija pokrenuta.'
      try {
        if (error.response && error.response.data && typeof error.response.data.text === 'function') {
          const tekst = await error.response.data.text()
          if (tekst && tekst.trim()) poruka = tekst
        }
      } catch (e) { /* ako ni poruka ne stigne, ostaje podrazumevani tekst */ }
      MySwal.fire({
        icon: 'error',
        title: 'PDF nije napravljen',
        text: poruka,
        confirmButtonText: 'U redu'
      })
    })
  }

  const savePreview = (planData) => {
    localStorage.setItem("previewData", JSON.stringify(planData));
  }

  const showTextAreas = [...Array(noOfCommentRows)].map((elementInArray, index) => {
    return (
      <textarea key={index}
        onChange={(e) => addComment(e.target.value, index)}
        value={planData ? planData.comments ? planData.comments[index] : '' : ''}
        className="w-full flex h-24 md:h-16 lg:h-12 py-2 px-4 text-left lg:text-lg font-medium border-t border-bluePrimary border-opacity-10"
        placeholder="Unesi komentar..."></textarea>
    );
  });
  return (
    <div>

      <div className="app">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="relative shadow before:absolute before:top-1/2 before:-translate-y-1/2 before:left-0 before:h-6 before:w-0.5 before:bg-blueSecondary">
              <tr>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Vreme</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Ponedeljak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Utorak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Sreda</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Četvrtak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Petak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Subota</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Nedelja</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(noOfRows)].map((elementInArray, index) => {

                return (
                  <tr key={((planData && (planData.id || 'nov')) + '|' + (planData && planData.menuNumber || '') + '|' + index)} className="border border-t-0 border-b-1 border-gray-100 last:border-0 text-gray-700 hover:bg-bluePrimary/10  transition animate-fadeIn">
                    <PlanTableCellHour existingTime={planData && planData["times"] && planData["times"][index] ? planData["times"][index] : null} timeIndex={index} setTime={setTime} isMerged={planData && planData.mergedRows && planData.mergedRows.includes(index)} toggleMerged={toggleMerged} lunchRecs={planData && planData.lunchRecommendationRows && planData.lunchRecommendationRows.includes(index)} toggleLunchRecs={toggleLunchRecs} />
                    {planData && planData.mergedRows && planData.mergedRows.includes(index) ?
                      (() => {
                        const mergedForRow = (planData.mergedDays && planData.mergedDays[index]) ? planData.mergedDays[index] : ALL_DAYS;
                        const cells = [];
                        let run = [];
                        ALL_DAYS.forEach(day => {
                          if (mergedForRow.includes(day)) {
                            run.push(day);
                          } else {
                            if (run.length) { cells.push({ type: 'merged', days: [...run] }); run = []; }
                            cells.push({ type: 'single', day });
                          }
                        });
                        if (run.length) cells.push({ type: 'merged', days: [...run] });
                        return cells.map((cell, ci) => cell.type === 'merged' ?
                          <PlanTableCellMerged key={ci} planData={planData} mealIndex={index} days={cell.days} toggleMergedDay={toggleMergedDay} />
                          :
                          <PlanTableCellDay key={ci} existingRecipes={planData && planData[cell.day] && planData[cell.day][index] ? planData[cell.day][index] : null} options={options} day={cell.day} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} showMergeToggle={true} onMergeToggle={toggleMergedDay} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                        );
                      })()
                      : <>
                    <PlanTableCellDay existingRecipes={planData && planData["monday"] && planData["monday"][index] ? planData["monday"][index] : null} options={options} day={"monday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                    <PlanTableCellDay existingRecipes={planData && planData["tuesday"] && planData["tuesday"][index] ? planData["tuesday"][index] : null} options={options} day={"tuesday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                    <PlanTableCellDay existingRecipes={planData && planData["wednesday"] && planData["wednesday"][index] ? planData["wednesday"][index] : null} options={options} day={"wednesday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                    <PlanTableCellDay existingRecipes={planData && planData["thursday"] && planData["thursday"][index] ? planData["thursday"][index] : null} options={options} day={"thursday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                    <PlanTableCellDay existingRecipes={planData && planData["friday"] && planData["friday"][index] ? planData["friday"][index] : null} options={options} day={"friday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                    <PlanTableCellDay existingRecipes={planData && planData["saturday"] && planData["saturday"][index] ? planData["saturday"][index] : null} options={options} day={"saturday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                    <PlanTableCellDay existingRecipes={planData && planData["sunday"] && planData["sunday"][index] ? planData["sunday"][index] : null} options={options} day={"sunday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} selectedClient={selectedClient} usedRecipes={usedRecipes} />
                    </>}
                  </tr>
                );
              })}
              <tr className="border border-t-0 border-b-1 border-gray-100 last:border-0 text-gray-700 hover:bg-bluePrimary/10  transition animate-fadeIn">
                <PlanTableCellSum displayStats={false} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["monday"] ? [...planData["monday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["tuesday"] ? [...planData["tuesday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["wednesday"] ? [...planData["wednesday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["thursday"] ? [...planData["thursday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["friday"] ? [...planData["friday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["saturday"] ? [...planData["saturday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["sunday"] ? [...planData["sunday"]] : null} />
              </tr>

            </tbody>
          </table>
        </div>
        <div className="flex justify-between p-4 font-medium shadow-[0_-1px_3px_0_rgba(0,0,0,0.1)]">
          <div className="flex md:items-center flex-col md:flex-row">
            <button type="button" className="button with-icon bg-blueSecondary mt-3 md:mt-0 md:mr-3" onClick={() => setNoOfRows(noOfRows + 1, planIndex)}>Dodaj <PlusIcon /></button>
            <button type="button" className="button with-icon bg-red-500 mt-3 md:mt-0" onClick={() => {
              if (noOfRows !== 0) { setNoOfRows(noOfRows - 1, planIndex) }
            }}>Obriši <XIcon /></button>
            <div className="ml-3">Kopiraj od</div>
            <div className="ml-3">
              <Select
                className='w-60'
                placeholder={'Pretraži...'}
                onChange={(item) => selectExistingClientsPlan(item.id, planIndex)}
                options={clients}
                classNamePrefix='select'
              />
            </div>
          </div>
        </div>
      </div >

      <div>
        {showTextAreas}

        <div className="px-4 pt-4">
          <label className="block mb-1 font-medium text-gray-700">Individualne preporuke</label>
          <textarea
            className="w-full border border-gray-300 rounded p-2 text-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-blueSecondary"
            rows={10}
            value={(planData && planData.individualRecommendations) || ''}
            onChange={(e) => setIndividualRecommendations(e.target.value)}
            placeholder="npr. Tečnost: ...   /   *Trikovi...:   /   - stavka   /   Kafa: ...   /   Fizička aktivnost: ..."
          />
        </div>

        <div className="flex flex-col sm:flex-row  justify-between xl:items-center p-4 font-medium shadow-[0_-1px_3px_0_rgba(0,0,0,0.1)]">
          <div className="flex md:items-center h-max flex-col md:flex-row">
            <button type="button" className="button with-icon bg-blueSecondary mt-3 md:mt-0 md:mr-3" onClick={() => setNoCommentOfRows(noOfCommentRows + 1, planIndex)}>Dodaj komentar <PlusIcon /></button>
            <button type="button" className="button with-icon bg-red-500 mt-3 md:mt-0" onClick={() => removeComment()}>Obriši Komentar <XIcon /></button>
            <div className="flex items-center mt-3 md:mt-0 md:ml-3">
              <span className="mr-2 whitespace-nowrap">Zamenske namirnice:</span>
              <Select
                className='w-52'
                value={SUBSTITUTE_SET_OPTIONS.find(o => o.value === ((planData && planData.substituteSet) || 'regular'))}
                onChange={(item) => setSubstituteSet(item.value)}
                options={SUBSTITUTE_SET_OPTIONS}
                classNamePrefix='select'
              />
            </div>
          </div>
          <div className="flex flex-col lg:flex-row xl:items-center">
            <div className="flex flex-col xl:flex-row">
              <Link className="button with-icon bg-teal-400 mt-3 md:mt-0 lg:mr-3" to={{
                pathname: "/preview",
                state: { value: planData },
              }} onClick={() => { savePreview(planData) }} target="_blank" rel="noopener noreferrer"> Pregled <EyeIcon /></Link>
              <button type="button" className="button with-icon bg-teal-400 mt-3 md:mt-0 lg:mr-3" onClick={() => downloadPdf()}>Preuzmi PDF <DownloadIcon /></button>
              <button type="button" className="button with-icon  bg-blueSecondary mt-3  xl:mt-0 lg:mr-3" onClick={() => addPlan(planIndex)}>Napravi novi plan <PlusIcon /></button>
            </div>
            <div className="flex flex-col xl:flex-row">
              <button type="button" className="button with-icon bg-teal-400 mt-3 lg:mt-0 xl:mr-3" onClick={() => savePlan(planIndex)}>Sačuvaj <SaveIcon /></button>
              <button type="button" className="button with-icon bg-slate-500 mt-3 xl:mt-0" onClick={() => sendPlan(planIndex)}>Pošalji <UploadIcon /></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabContent
